export const isMobile = () => window.innerWidth < 768

export const isIE = () => navigator.userAgent.indexOf('Trident/7.0') >= 0

export default {
  isMobile,
  isIE,
}
